import React from 'react';
import type { LinkProps } from 'react-router-dom';
import { Link as ReactLink } from 'react-router-dom';
import {
  ELEMENT_ID_DATA_LOG_ATTRIBUTE,
  DataElementId,
  ELEMENT_ID_DATA_TEST_ATTRIBUTE,
} from '../../../constants/data-element-tracking-ids';

export const LogoLink: React.FC<
{
  homepagePath: string;
} & Omit<LinkProps, 'to'>
> = ({ homepagePath, ...props }) => (
  <ReactLink
    to={homepagePath}
    {...{
      [ELEMENT_ID_DATA_LOG_ATTRIBUTE]: DataElementId.LOGO_LINK,
      [ELEMENT_ID_DATA_TEST_ATTRIBUTE]: DataElementId.LOGO_LINK,
    }}
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
  />
);
